<template>
  <q-dialog
    :content-class="['slide-up-dialog', dialogData.componentName === 'Privacy' ? 'small-dialog' : '']"
    v-model="dialogData.dialogDisplay"
    persistent
    :maximized="maximizedToggle"
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card class="bg-white">
      <q-bar>
        <div class="slide-up-title">{{ dialogData.title }}</div>
        <q-btn dense flat icon="close" @click="closeDialog()" v-close-popup>
          <q-tooltip content-class="bg-white text-primary">Close</q-tooltip>
        </q-btn>
      </q-bar>
      <!-- 內容 -->
      <q-card-section>
        <!-- 透過父層傳入要顯示的 component 內容名稱 -->
        <component :is="dialogData.componentName" :dialogContentData="dialogData.contentData"></component>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
// TODO: 更好的寫法應該要在父層指定要引用的 component 路徑，用動態載入的方式載入所需的 component，目前還需手動來此新增 import
// 先引用內容的 component
import OtherTagList from '@/components/PostWall/OtherTagList';
export default {
  name: 'SlideUpDialog',
  props: ['dialogData'],
  components: {
    OtherTagList
  },
  data() {
    return {
      maximizedToggle: true
    };
  },
  methods: {
    // 關閉 dialog (#SlideUpDialog-function)
    closeDialog() {
      this.$emit('changeDisplay', false);
    }
  }
};
</script>

<!-- 全域的 -->
<style lang="scss">
.slide-up-dialog {
  background-color: #00000080;

  .q-card {
    border-radius: 11px 11px 0 0 !important;
    overflow: hidden;
    top: 10%;
  }

  .q-dialog__backdrop {
    background: transparent;
  }

  .q-bar {
    background: transparent;
    margin: 8px 0;
    border-bottom: 1px solid #e9ecef !important;
    padding: 0 5px 8px 5px;
  }

  .q-icon {
    font-size: 28px;
    color: $LaleNotActiveGray;
  }

  .slide-up-title {
    width: calc(100% - 35px);
    text-align: center;
    color: $LaleNotActiveGray;
    left: 15px;
    position: relative;
  }

  .q-bar--standard {
    height: auto;
  }
}
</style>
